/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import navbarContext, { NavbarContext } from './navbarContext';

export const useNavbar = (): NavbarContext =>
  React.useContext<NavbarContext>(navbarContext);
